import RequestAbstract from "./RequestAbstract";

export default class accounts extends RequestAbstract {
  get link() {
    return this.links.accounts;
  }

  async getAll(sort = [], filter = [], companyType) {
    const sortField = this.getSortField("social_type");

    return await this.post(this.link, {
      sort: sortField,
      filter,
      companyType,
      paging: { page: 1, pageSize: 1000000000 },
    });
  }

  async newPost(info) {
    return await this.post(this.link + "/new-post", info);
  }

  async saveDraft(info) {
    return await this.post(this.link + "/save-draft", info);
  }

  async generateTags(info) {
    return await this.post(this.link + "/generate-hashtags", info);
  }

  async saveWaterMark(info) {
    return await this.post(this.link + "/addWaterMark", info);
  }

  async removeWaterMark(info) {
    return await this.post(this.link + "/removeWaterMark", info);
  }
  async uploadImage(info) {
    return await this.postFormData(this.link + "/uploadImage", info);
  }

  async removeImage(info) {
    return await this.post(this.link + "/deleteImageProfile", info);
  }

  get thumbnailProfile() {
    return this.link + "/thumbnailProfile";
  }

  get thumbnailAccount() {
    return this.link + "/thumbnailAccount";
  }

  formLink(id, size) {
    const link = this.thumbnailProfile;
    return this.getFullLink(`${link}/${id}/${size}`);
  }

  formLinkSocial(id) {
    const link = this.thumbnailAccount;
    return this.getFullLink(`${link}/${id}/300`);
  }

  // Telegram specific methods
  async getTelegramChats(botToken) {
    try {
      const response = await this.get(
        `${this.link}/telegram/available-chats?access_token=${encodeURIComponent(botToken)}`,
      );
      return response;
    } catch (error) {
      console.error("Error fetching Telegram chats:", error);
      return { isOk: false, error: error.message };
    }
  }

  async addTelegramAccount(botToken, chatId) {
    return await this.add({
      social_type: "telegram",
      access_token: botToken,
      chat_id: chatId,
    });
  }

  // TikTok Creator Info — must be called before showing the TikTok settings UI.
  // Returns privacy_level_options, forced disable toggles, max video duration,
  // and the creator identity (avatar/nickname/username) required by TikTok
  // App Review guidelines. Cached server-side for 1h; pass refresh=true to
  // force a fresh call to TikTok.
  async getTikTokCreatorInfo(accountId, refresh = false) {
    const qs = refresh ? "?refresh=1" : "";
    return await this.get(`${this.link}/provider-info/${accountId}${qs}`);
  }

  // Analytics of one account for a period ("7d" | "28d" | "90d"), OP#3453.
  // Silent: a failure belongs to this account's block (it reads data.code), so it
  // must not raise the global alert. No mock fallback on purpose.
  async analytics(id, period = "28d") {
    return await this.getSilent(
      `${this.link}/analytics/${encodeURIComponent(id)}?period=${encodeURIComponent(period)}`,
    );
  }

  // Sets the default publish mode ("direct" | "inbox") for a TikTok account.
  // Per-post publish_mode always wins over this preference.
  async setTikTokPreferences(accountId, publishMode) {
    return await this.post(`${this.link}/tiktok-preferences/${accountId}`, {
      publish_mode: publishMode,
    });
  }
}
